import React from "react";
import "./style.scss";

import { sanitizeContent as s, replaceVariablesInText } from "../../../util/functions";
import { Header } from "./StepHeading.types";

const StepHeading = (props: Header) => {
  const {
    title,
    subtitle,
    description,
    type
  } = props;

  const processedTitle = title ? replaceVariablesInText(title) : "";
  const processedSubtitle = subtitle ? replaceVariablesInText(subtitle) : "";
  const processedDescription = description ? replaceVariablesInText(description) : "";

  return (
    <div className={`fc-step-header StepHeading StepHeading--${type}`}>
      {title && (
      <h2
        className={`fc-step-header-title StepHeading__title`}
        dangerouslySetInnerHTML={{ __html: s(processedTitle) }} />
      )}
      {subtitle && (
      <div
        className={`fc-step-header-subtitle StepHeading__subtitle`}
        dangerouslySetInnerHTML={{ __html: s(processedSubtitle) }} />
      )}
      {description && (
        <div
        className={`fc-step-header-description StepHeading__description`}
        dangerouslySetInnerHTML={{ __html: s(processedDescription) }} />
      )}
      
    </div>
  )
}

export default StepHeading;